var exports = {
  "kL": "InlineAudioPlayer.module__container___X3dfdV",
  "wx": "InlineAudioPlayer.module__header___X3dfdV",
  "Rr": "InlineAudioPlayer.module__playButton___X3dfdV",
  "CJ": "InlineAudioPlayer.module__playButtonIcon___X3dfdV",
  "sp": "InlineAudioPlayer.module__loadingSpinnerDesktop___X3dfdV",
  "t0": "InlineAudioPlayer.module__spin___X3dfdV",
  "XE": "InlineAudioPlayer.module__fileInfo___X3dfdV",
  "Md": "InlineAudioPlayer.module__fileName___X3dfdV",
  "m$": "InlineAudioPlayer.module__fileNameTruncate___X3dfdV",
  "i_": "InlineAudioPlayer.module__fileExtension___X3dfdV",
  "gM": "InlineAudioPlayer.module__fileMeta___X3dfdV",
  "NE": "InlineAudioPlayer.module__progressSection___X3dfdV",
  "hr": "InlineAudioPlayer.module__progressBar___X3dfdV",
  "Td": "InlineAudioPlayer.module__time___X3dfdV",
  "ne": "InlineAudioPlayer.module__controls___X3dfdV",
  "it": "InlineAudioPlayer.module__controlsLeft___X3dfdV",
  "BT": "InlineAudioPlayer.module__controlsRight___X3dfdV",
  "Wq": "InlineAudioPlayer.module__volumeControl___X3dfdV",
  "hP": "InlineAudioPlayer.module__actionButton___X3dfdV",
  "AA": "InlineAudioPlayer.module__mobileContainer___X3dfdV",
  "xk": "InlineAudioPlayer.module__mobilePlayButton___X3dfdV",
  "S": "InlineAudioPlayer.module__loadingSpinner___X3dfdV",
  "_S": "InlineAudioPlayer.module__mobileContainerActive___X3dfdV",
  "wh": "InlineAudioPlayer.module__mobileContent___X3dfdV",
  "Vg": "InlineAudioPlayer.module__mobileFileInfo___X3dfdV",
  "Yg": "InlineAudioPlayer.module__mobileFileName___X3dfdV",
  "kB": "InlineAudioPlayer.module__mobileFileMeta___X3dfdV",
  "hb": "InlineAudioPlayer.module__mobileProgressContainer___X3dfdV",
  "jw": "InlineAudioPlayer.module__mobileProgressTrack___X3dfdV",
  "lm": "InlineAudioPlayer.module__mobileProgressTrackActive___X3dfdV",
  "$r": "InlineAudioPlayer.module__mobileProgressFill___X3dfdV",
  "LI": "InlineAudioPlayer.module__mobileProgressFillActive___X3dfdV",
  "zr": "InlineAudioPlayer.module__mobileTimestamp___X3dfdV",
};

module.exports = exports;
